var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('el-carousel',{attrs:{"interval":5000,"arrow":"never"}},_vm._l((_vm.Bannerswip),function(item,index){return _c('el-carousel-item',{key:index,staticClass:"text_center"},[_c('img',{attrs:{"src":item.resUrl,"alt":""},on:{"click":function($event){return _vm.tourl(item.url)}}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }